export const maxPostgreSQLInt = 2 ** 31 - 1;
export const defaultTenantName = 'Next Street';
